import * as React from 'react';

// MaterialUI
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/ButtonBase';
import Typography from '@mui/material/Typography';

const ImgButton = styled(ButtonBase)(({ theme }) => ({
  position: 'relative',
  height: 100,
	'&:hover, &.Mui-focusVisible': {
		zIndex: 1,
		'& .MuiImageBackdrop-root': {
			opacity: 0.5,
		},
		'& .MuiImageMarked-root': {
			opacity: 1,
		},
		'& .MuiImageButton-root': {
			border: '4px solid currentColor',
		},
	},
}));

const ImgSrc = styled('span')({
	position: 'absolute',
	left: 0,
	right: 0,
	top: 0,
	bottom: 0,
	backgroundSize: 'cover',
	backgroundPosition: 'center',
});

const Img = styled('span')(({ theme }) => ({
	position: 'absolute',
	left: 0,
	right: 0,
	top: 0,
	bottom: 0,
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	color: theme.palette.common.black,
	textShadow: '.85px .85px 1.5px #0F1820',
}));

const ImgBackdrop = styled('span')(({ theme }) => ({
	position: 'absolute',
	left: 0,
	right: 0,
	top: 0,
	bottom: 0,
	backgroundColor: theme.palette.common.white,
	opacity: 0,
	// transition: theme.transitions.create('opacity'),
}));

const ImgMarked = styled('span')(({ theme }) => ({
	height: 5,
	width: 24,
	backgroundColor: theme.palette.common.black,
	position: 'absolute',
	bottom: 12,
	left: `calc(50% - 12px)`,
	opacity: 0,
	// transition: theme.transitions.create('opacity'),
}));

export default function ImageButton(props) {
	const { imgUrl, imgWidth, imgHeight, buttonText, linkUrl } = props;

	return (
		<Box
			sx={{
				display: 'flex',
				flexWrap: 'wrap',
				minWidth: 10,
				width: '100%',
				p: '2px',
			}}
		>
			<ImgButton
				href={linkUrl}
				focusRipple
				key={buttonText}
				style={{
					width: imgWidth,
					height: imgHeight,
				}}
				className="MuiImageButton-root"
			>
				<ImgSrc style={{ backgroundImage: `url(${imgUrl})` }} />
				<ImgBackdrop className="MuiImageBackdrop-root" />
				<Img>
					<Typography
						component="span"
						variant="subtitle"
						color="inherit"
						fontFamily='Saira, sans-serif'
						fontWeight={600}
						fontSize={20}
						sx={{
							position: 'relative',
							p: 4,
							pt: 2,
							pb: (theme) => `calc(${theme.spacing(1)} + 6px)`,
						}}
					>
						{buttonText}
						<ImgMarked className="MuiImageMarked-root" />
					</Typography>
				</Img>
			</ImgButton>
		</Box>
	);
}